import ApiService from '@/services/api'

const state = {
  loading: false,
  error: null
}

const getters = {
  isLoading: state => state.loading,
  getError: state => state.error
}

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  CLEAR_ERROR(state) {
    state.error = null
  }
}

const actions = {
  /**
   * Adiciona uma habilidade ao usuário
   * @param {object} skillData - Dados da habilidade do usuário
   */
  async addUsuarioSkill({ commit }, skillData) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      const response = await ApiService.post('/UsuarioSkills', skillData)
      
      commit('SET_LOADING', false)
      
      return { success: true, data: response }
      
    } catch (error) {
      commit('SET_LOADING', false)
      
      let errorMessage = 'Erro ao adicionar habilidade'
      
      if (error.message) {
        errorMessage = error.message
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message
      } else if (typeof error === 'string') {
        errorMessage = error
      }
      
      commit('SET_ERROR', errorMessage)
      return { success: false, error: errorMessage }
    }
  },

  /**
   * Remove uma habilidade do usuário
   * @param {string|number} id - ID da relação usuário-habilidade
   */
  async deleteUsuarioSkill({ commit }, id) {
    if (!id) {
      const errorMessage = 'ID é obrigatório para remover habilidade'
      commit('SET_ERROR', errorMessage)
      return { success: false, error: errorMessage }
    }

    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      await ApiService.delete(`/UsuarioSkills/${id}`)
      
      commit('SET_LOADING', false)
      
      return { success: true }
      
    } catch (error) {
      commit('SET_LOADING', false)
      
      let errorMessage = 'Erro ao remover habilidade'
      
      if (error.message) {
        errorMessage = error.message
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message
      } else if (typeof error === 'string') {
        errorMessage = error
      }
      
      commit('SET_ERROR', errorMessage)
      return { success: false, error: errorMessage }
    }
  },

  /**
   * Adiciona top 3 habilidades do usuário
   * @param {object} topSkillsData - Dados das top habilidades
   */
  async addTopSkills({ commit }, topSkillsData) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      const response = await ApiService.post('/UsuarioSkills/TopSkills', topSkillsData)
      
      commit('SET_LOADING', false)
      
      return { success: true, data: response }
      
    } catch (error) {
      commit('SET_LOADING', false)
      
      let errorMessage = 'Erro ao salvar top habilidades'
      
      if (error.message) {
        errorMessage = error.message
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message
      } else if (typeof error === 'string') {
        errorMessage = error
      }
      
      commit('SET_ERROR', errorMessage)
      return { success: false, error: errorMessage }
    }
  },

  /**
   * Limpa o erro
   */
  clearError({ commit }) {
    commit('CLEAR_ERROR')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
